import { Button, CloseButton, Flex, Heading, Text } from '@chakra-ui/react';
import { SurveyPopUpData } from './SurveyPopUpData';
import { useEffect, useState } from 'react';
import { markClickedToTakeSurvey } from './RecentSurveys';
import { trackEventInPiwik } from 'Shared/Analytics/Piwik/PiwikEvent';

type TrackInPiwikParams = {
   id: string;
   title: string;
   click: boolean;
};

const trackSurveyInPiwik = ({ id, title, click }: TrackInPiwikParams) => {
   const action = click ? 'Button - Click' : 'View';
   const capitalizedId = id.charAt(0).toUpperCase() + id.slice(1);
   trackEventInPiwik({
      eventCategory: `Survey Pop Up - ${capitalizedId}`,
      eventAction: `Survey Pop Up - ${capitalizedId} - ${action}`,
      eventName: `Survey - ${title}`,
   });
};

interface MarkSurveySeen {
   markSurveySeen: () => void;
}

type SurveyPopUpProps = SurveyPopUpData & MarkSurveySeen;

export const SurveyPopUp = ({ id, title, description, link, markSurveySeen }: SurveyPopUpProps) => {
   const [isClosed, setIsClosed] = useState(false);

   const onClose = () => {
      setIsClosed(true);
   };
   const clickSurvey = () => {
      window.location.href = link;
      markClickedToTakeSurvey(id);
      trackSurveyInPiwik({ id, title, click: true });
   };

   const viewSurvey = () => {
      markSurveySeen();
      trackSurveyInPiwik({ id, title, click: false });
   };

   useEffect(viewSurvey, []);

   return (
      <>
         {!isClosed && (
            <Flex
               id={`survey-pop-up`}
               padding={{ base: '16px', sm: '24px' }}
               flexDirection="column"
               gap="12px"
               bgColor="white"
               position="fixed"
               textAlign="center"
               width={{ base: 'auto', sm: '320px' }}
               bottom={{ base: '15px', sm: '20px' }}
               right={{ base: '15px', sm: '20px' }}
               left={{ base: '15px', sm: 'auto' }}
               zIndex="9"
               boxShadow="0px 4px 6px -1px rgba(0, 0, 0, 0.10), 0px 2px 4px -2px rgba(0, 0, 0, 0.10)"
               borderRadius="4px"
               borderWidth={1}
            >
               <Heading
                  as="h4"
                  color="black"
                  fontSize="20px"
                  fontWeight="500"
                  lineHeight="normal"
                  margin="0"
               >
                  {title}
               </Heading>
               <CloseButton
                  boxSize="20px"
                  position="absolute"
                  top="18px"
                  right="18px"
                  color="gray.400"
                  onClick={onClose}
               />
               <Text margin="0" color="gray.500">
                  {description}
               </Text>
               <Button
                  id="take-survey-button"
                  variant="cta"
                  marginInline="auto"
                  onClick={clickSurvey}
               >
                  Take the Survey
               </Button>
            </Flex>
         )}
      </>
   );
};
